import axios from '../utils/axios';

// Sprint 6 cutover: wraps /api/my-pages/customer-users (the admin/säljare
// CRUD over the `customer_user` table). Used by AdminClientList.js and the
// CreateUser form when creating "kund" logins.

export const listCustomerUsers = async (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      usp.append(key, value);
    }
  });
  const qs = usp.toString();
  const { data } = await axios.get(`/api/my-pages/customer-users${qs ? `?${qs}` : ''}`);
  return data;
};

export const getCustomerUser = async (id) => {
  const { data } = await axios.get(`/api/my-pages/customer-users/${id}`);
  return data;
};

export const createCustomerUser = async ({ email, name, companyName, customerId }) => {
  const { data } = await axios.post('/api/my-pages/customer-users', {
    email,
    name,
    companyName,
    // eslint-disable-next-line camelcase
    customer_id: customerId,
  });
  return data;
};

export const updateCustomerUser = async (id, patch) => {
  const { data } = await axios.put(`/api/my-pages/customer-users/${id}`, patch);
  return data;
};

export const sendCustomerUserInvite = async (id) => {
  const { data } = await axios.post(`/api/my-pages/customer-users/${id}/invite`);
  return data;
};

export const getCustomerInviteLink = async (id) => {
  const { data } = await axios.get(`/api/my-pages/customer-users/${id}/invite-link`);
  return data;
};

export const deleteCustomerUser = async (id) => {
  const { data } = await axios.delete(`/api/my-pages/customer-users/${id}`);
  return data;
};
